<script lang="ts">
  import type { PromoImage } from "$lib/gql/genCms/codegen";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import StaticImage from "$lib/components/StaticImage/StaticImage.svelte";
  import inView from "$lib/utils/inView";
  import { linkTo } from "$lib/utils/url";

  export let promoImage: PromoImage;
  export let twoColumnLayout = false;
  let hovered = false;
  let isInView = false;
</script>

<style lang="scss">
  .promo-image {
    padding: 24px 0;
    display: flex;
    flex-direction: column;

    @include breakpoint(lg) {
      padding-bottom: 0;
    }

    &--two-column {
      @include breakpoint(lg) {
        padding: 0;
      }
    }

    &--link {
      text-decoration: none;
    }

    &--text {
      padding: 16px 0;
    }
  }
</style>

{#if promoImage.image && promoImage.image.uri}
  <div
    use:inView={{
      threshold: 0.1,
    }}
    on:intersect={({ detail }) => {
      if (detail) {
        isInView = true;
      }
    }}
    class="promo-image {twoColumnLayout ? 'promo-image--two-column' : ''}"
  >
    {#if isInView}
      {#if promoImage.link && promoImage.link.href}
        <a
          class="promo-image--link"
          href={linkTo(promoImage.link.href)}
          on:mouseenter={() => (hovered = true)}
          on:mouseleave={() => (hovered = false)}
        >
          <StaticImage
            smImage={promoImage.image.uri}
            mdImage={promoImage.image.uri}
            lgImage={promoImage.image.uri}
            altText={promoImage.image.altText}
            smSize={{
              width: twoColumnLayout ? 360 : 312,
              height: twoColumnLayout ? 360 : 312,
            }}
            mdSize={{
              width: twoColumnLayout ? 360 : 320,
              height: twoColumnLayout ? 360 : 320,
            }}
            lgSize={{
              width: twoColumnLayout ? 360 : 340,
              height: twoColumnLayout ? 360 : 340,
            }}
            xlSize={{
              width: twoColumnLayout ? 575 : 600,
              height: twoColumnLayout ? 575 : 600,
            }}
            fallbackSize={{
              width: twoColumnLayout ? 360 : 320,
              height: twoColumnLayout ? 360 : 320,
            }}
            imgFromUrl
          />

          {#if promoImage.link && promoImage.link?.text !== "" && !twoColumnLayout}
            <div class="promo-image--text">
              <Typography
                variant="button1"
                theme={hovered ? "on-surface-30" : "on-surface"}
                >{promoImage.link.text}</Typography
              >
            </div>
          {/if}
        </a>
      {:else}
        <StaticImage
          smImage={promoImage.image.uri}
          mdImage={promoImage.image.uri}
          lgImage={promoImage.image.uri}
          altText={promoImage.image.altText}
          smSize={{
            width: twoColumnLayout ? 360 : 312,
            height: twoColumnLayout ? 360 : 312,
          }}
          mdSize={{
            width: twoColumnLayout ? 360 : 320,
            height: twoColumnLayout ? 360 : 320,
          }}
          lgSize={{
            width: twoColumnLayout ? 360 : 340,
            height: twoColumnLayout ? 360 : 340,
          }}
          xlSize={{
            width: twoColumnLayout ? 575 : 600,
            height: twoColumnLayout ? 575 : 600,
          }}
          fallbackSize={{
            width: twoColumnLayout ? 360 : 320,
            height: twoColumnLayout ? 360 : 320,
          }}
          imgFromUrl
        />
      {/if}
    {/if}
  </div>
{/if}
